//============================================================================
// Name        : item_group.ts
// Purpose     : Implement item group logic
// Created     : 2021-02-22
// Author      : Alireza Mohagheghi
// Copyright   : Copyright 2021 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";

declare var client_store_merge_item_group_modal_path: string;
declare var client_store_split_item_group_modal_path: string;

class InitButtons {
    constructor() {
        $(document).on("change", () => {
            if ($("[id^=epc_tags_]:checked").length > 1) {
                $("#btn-merge").removeClass("disabled");
                $("#btn-split").addClass("disabled");
            } else if ($("[id^=epc_tags_]:checked").length === 1) {
                $("#btn-merge").addClass("disabled");
                $("#btn-split").removeClass("disabled");
            } else {
                $("#btn-merge").addClass("disabled");
                $("#btn-split").addClass("disabled");
            }
        });

        $("#btn-merge").on("click", (e) => {
            e.preventDefault();
            const array = [];
            $("[id^=epc_tags_]:checked").each(function() {
                array.push($(this).val());
            });
            if (array.length < 2) return;

            $.ajax({
                type: "GET",
                url: client_store_merge_item_group_modal_path,
                data: {
                    epc_tag_ids: array
                }
            });
        });

        $("#btn-split").on("click", (e) => {
            e.preventDefault();
            if ($("[id^=epc_tags_]:checked").length !== 1) return;
            $.ajax({
                type: "GET",
                url: client_store_split_item_group_modal_path,
                data: {epc_tag_id: $("[id^=epc_tags_]:checked").val()}
            });
        });

    }
}

export function LoadPage() {
    InitPage("items item_group", () => {
        const init_btns = new InitButtons();
    });
}
